import { func } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import File from '../../generic/File';
import { commentShape } from '../../prop-types';
import api from '../../REST/api';
import { updateComment } from '../actions';
import { sliceUp } from '../mention-utils';

class CommentBody extends React.PureComponent {
  state = {
    commentExpand: false,
  };

  toggleComment = bool => {
    this.setState({ commentExpand: bool });
  };

  deleteAttachment = (comment, file) => {
    const { onUpdateComment } = this.props;
    const updatedComment = {
      ...comment,
      attachments: comment.attachments.filter(item => item.id !== file.id),
    };
    onUpdateComment(updatedComment);
  };

  renderComment = text => {
    const { model } = this.props;
    const { mentions } = model;
    const { commentExpand } = this.state;
    const textToRender =
      commentExpand || text.length < 150
        ? text
        : `${text.substring(0, 150)}...`;
    /* eslint-disable react/no-array-index-key */
    return (
      <>
        {sliceUp(textToRender, mentions).map((slice, idx) =>
          slice.href ? (
            <a key={idx} href={slice.href} target="_blank" rel="noreferrer">
              {slice.text}
            </a>
          ) : (
            <span key={idx}>{slice.text}</span>
          ),
        )}
        {textToRender.length > 150 && this.renderButton()}
      </>
    );
  };

  renderButton() {
    const { commentExpand } = this.state;
    return (
      <div>
        <Button
          type="button"
          color="primary"
          className="mt-2"
          size="sm"
          onClick={() => this.toggleComment(!commentExpand)}
        >
          {commentExpand ? 'Show less' : 'Show more'}
        </Button>
      </div>
    );
  }

  render() {
    const { model } = this.props;
    const { text, mentions, attachments } = model;
    const commentText = sliceUp(text, mentions)
      .map(item => item.text)
      .join('');
    /* eslint-disable react/no-array-index-key */
    return (
      <div className="c-comment__body">
        {this.renderComment(commentText)}
        {attachments.length > 0 && (
          <div className="d-grid grid-col-3 mt-2">
            {attachments.map(attachment => (
              <File
                key={attachment.id}
                file={attachment}
                view="compact"
                onDeleteFile={api.destroyAttachment}
                onDeleteFileSuccess={() =>
                  this.deleteAttachment(model, attachment)
                } // eslint-disable-line react/jsx-curly-newline
                onGetFile={api.downloadAttachment}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

CommentBody.propTypes = {
  model: commentShape.isRequired,
  onUpdateComment: func.isRequired,
};

const mapDispatchToProps = {
  onUpdateComment: updateComment,
};

export default connect(null, mapDispatchToProps)(CommentBody);
